import React, { useCallback, useEffect, useState } from "react";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import { Box, Button, Paper, Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getLeadTypes, getOgmLeads } from "../../../redux/features/ogdSlice";
import dayjs, { Dayjs } from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { OGA_LEADS_TABLE_HEAD } from "../../../components/datagrid/myworkspace/ogd/ogmLeads/OgaLeadsTableHead";
import { UpdateLeavdView } from "../../../components/datagrid/myworkspace/ogd/ogmLeads/RenderCellMain";
import GlobalDatagrid from "../../../components/mui/DataGrid/GlobalDatagrid";
import GlobalAnchorList from "../../../components/mui/GlobalAnchor/GlobalAnchorList";
import ActionDetails from "../../../components/mui/GlobalAnchor/ActionDetails";
import { savePaginationData } from "../../../redux/features/globalDatagridSlice";
import LeadSingleView from "./LeadSingleView";

const OgaLeads = () => {
  const dispatch = useDispatch();
  const { leadType, ogmLeads, loading } = useSelector((state) => state.ogd);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  const [value, setValue] = useState(dayjs());
  const [leadTypes, seLeasTypes] = useState(1);

  const handleChange = (event) => {
    seLeasTypes(event.target.value);
  };
  const data = {
    page: pageNum,
    limit: gridSize,
  };
  useEffect(() => {
    const datas = {
      ...data,
      date: dayjs(value).format("YYYY-MM"),
      leadType: leadTypes,
      search: search,
    };
    if (data.limit && data.page) {
      dispatch(getOgmLeads(datas));
    }
  }, [leadTypes, value, pageNum, gridSize, search]);

  useEffect(() => {
    dispatch(getLeadTypes());
  }, []);
  useEffect(() => {
    dispatch(savePaginationData({ ...paginationData, pageNum: 1 }));
  }, [value, leadTypes, search]);

  const UpdateData = {
    ...data,
    date: dayjs(value).format("YYYY-MM"),
    leadType: leadTypes,
    leadId: rowData?.lead_id,
    openAnchor,
    search: search,
  };

  return (
    <GlobalWrapper title={"OGA Leads"}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", pb: 2 }}>
        <Stack direction={"row"} spacing={2}>
          <Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Year/Month"
                value={value}
                views={["year", "month"]}
                format="YYYY-MM" //
                onChange={(newValue) => setValue(newValue)}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ minWidth: 150 }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Lead Types</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={leadTypes}
                label="Lead Types"
                onChange={handleChange}
              >
                {leadType.map((item) => {
                  return (
                    <MenuItem key={item.lead_type_id} value={item.lead_type_id}>
                      {item.lead_type_name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Box>
        </Stack>
      </Box>
      <Paper elevation={3}>
        <Box sx={{ width: "100%", padding: 0 }}>
          <GlobalDatagrid
            tableHead={OGA_LEADS_TABLE_HEAD}
            rows={ogmLeads?.data?.ogmLeads}
            meta={ogmLeads?.meta?.totalRecords || 0}
            rowUniqueId="sl_no"
            loading={loading}
            rowClick={true}
            actionComponent={
              <>
                <ActionDetails val={rowData?.lead_name} />
                <GlobalAnchorList
                  label="Update"
                  component={
                    <UpdateLeavdView
                      rowData={rowData}
                      updateData={UpdateData}
                    />
                  }
                />
                <GlobalAnchorList
                  label="Lead View"
                  component={<LeadSingleView rowData={rowData} />}
                />
              </>
            }
          />
        </Box>
      </Paper>
    </GlobalWrapper>
  );
};

export default OgaLeads;
